import React from 'react';
import { Container, Box, Button, Alert, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import UserProfile from '../../components/auth/UserProfile';
import { useAuth } from '../../contexts/AuthContext';
import PanelHero, { panelPageSx } from '../../components/layout/PanelHero';

const Profile: React.FC = () => {
  const { state } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!state.loading && !state.isAuthenticated) {
      navigate('/login');
    }
  }, [state.loading, state.isAuthenticated, navigate]);

  if (state.loading && !state.isAuthenticated) {
    return (
      <Box sx={{ ...panelPageSx, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress sx={{ color: '#C23535' }} />
      </Box>
    );
  }

  if (!state.isAuthenticated) {
    return (
      <Box sx={panelPageSx}>
        <Container maxWidth="sm" sx={{ pt: 8, textAlign: 'center' }}>
          <Alert severity="warning">
            Você precisa estar logado para acessar esta página.
          </Alert>
          <Button variant="contained" sx={{ mt: 2, bgcolor: '#C23535', '&:hover': { bgcolor: '#A52A2A' } }}
            onClick={() => navigate('/login')}>
            Fazer Login
          </Button>
        </Container>
      </Box>
    );
  }

  return (
    <Box sx={panelPageSx}>
      <PanelHero title="Painel de Gerenciamento" subtitle="" />

      <Container maxWidth="xl" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1.5, sm: 3 } }}>
        <UserProfile />
      </Container>
    </Box>
  );
};

export default Profile;
